import React from 'react';
import { css } from '@emotion/react';
import { i18n_explore_courses_and_challenges } from '@yi/i18n/phrases/i18n_explore_courses_and_challenges';

import { CourseCard } from '~/src/components/cards/CourseCard';
import { CourseCarousel } from '~/src/components/carousels/CourseCarousel';
import { LazyRender } from '~/src/components/LazyRender';
import { useLocale } from '~/src/components/LocaleProvider';
import { breakpoints } from '~/src/styles';
import { typography } from '~/src/styles/design-system';
import { fontWeight } from '~/src/styles/styled-variables';

import { CoursesCarouselDataEN } from './CoursesCarouselDataEN';
import { CoursesCarouselDataES } from './CoursesCarouselDataES';
import { carouselSettings, spaceBetweenCards } from '../carouselSettings';

const headerCSS = css(carouselSettings.headerCSS, {
  span: css(typography.heading2, {
    fontWeight: fontWeight.semiBold,
    textTransform: 'capitalize',
    color: 'var(--Dark-Text, #27292D)',
    margin: 0,
    [breakpoints.minTablet]: [
      typography.bodyText,
      {
        fontWeight: fontWeight.bold,
      },
    ],
    [breakpoints.minDesktop]: {
      color: 'var(--Dark-Text, #27292D)',
      fontSize: '32px',
      fontWeight: fontWeight.semiBold,
      lineHeight: '40px',
      letterSpacing: '1.6px',
    },
  }),
});

const Data: React.FC<{
  children: (data: React.ComponentProps<typeof CourseCarousel>['items']) => React.ReactNode;
}> = props => {
  const { locale } = useLocale();
  if (locale === 'es') {
    return <CoursesCarouselDataES {...props} />;
  }
  return <CoursesCarouselDataEN {...props} />;
};
export const CoursesCarousel: React.FC<{ className?: string }> = props => {
  const { locale } = useLocale();

  return (
    <div {...props}>
      <Data>
        {data => (
          <LazyRender
            placeholder={
              <CourseCarousel.Placeholder
                heading={i18n_explore_courses_and_challenges(locale)}
                button={null}
                headerCSS={carouselSettings.headerCSS}
              />
            }
          >
            <CourseCarousel
              items={data}
              heading={i18n_explore_courses_and_challenges(locale)}
              {...carouselSettings}
              deprecatedEnableCarouselInvisibleCard={true}
              headerCSS={headerCSS}
              style={{ width: `${CourseCard.dimension.width + spaceBetweenCards}px` }}
            />
          </LazyRender>
        )}
      </Data>
    </div>
  );
};
